import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Location from '../Location';
import { LocationType } from '../../types';
import { DS_palette as corePalette } from '../../../../../../../../mui/base/theme/DS_Tokens/core';

import { LoaderSpinner } from '../../../../../../../elements';

import countries from '../../../../../../../../mui/assets/data/countries';

import { StyledLocationList } from './styles';

const LocationsList = React.forwardRef(
  (
    {
      locations,
      distancePlaceholder,
      bookingButtonLabel,
      selectedLocationState,
      useFlagshipStoreLabel,
      timeLocationData,
      navigation,
      isGeoSearched,
      locationsRefs,
      slots,
      shouldPersonalDataCollected,
      displayedLocations,
      loading,
      setMounted,
      filtersDatesProps,
      allItemsDisplayed,
      useDiscountOnFlagship,
      discountFlagshipText,
    },
    ref,
  ) => {
    const {
      showTimeSlots,
      cancelDialogLabelLT,
      confirmationDialogLabelLT,
      waitlistButtonLabelLT,
      noDatesAvailableLT,
      waitlistSuccessLinkLT,
    } = timeLocationData;

    useEffect(() => {
      setMounted(true); // Update a state to signal that component has mounted
      return () => setMounted(false); // Cleanup function to reset on unmount
    }, []);

    const impressParisClinic = locations.filter(location => location.code === 'SHP');
    const country = countries[process.env.GATSBY_COUNTRY_CODE];
    const isFrance = country.lang === 'fr';

    const filteredLocations = (isGeoSearched ? locations : displayedLocations).filter(
      location => !(isFrance && location.code === 'SHP'),
    );

    const renderLocation = location => (
      <Location
        key={location.id}
        location={location}
        ref={locationsRefs && locationsRefs[location.id]}
        distancePlaceholder={distancePlaceholder}
        selectedLocationState={selectedLocationState}
        bookingButtonLabel={bookingButtonLabel}
        useFlagshipStoreLabel={useFlagshipStoreLabel}
        confirmationDialogLabelLT={confirmationDialogLabelLT}
        cancelDialogLabelLT={cancelDialogLabelLT}
        waitlistButtonLabelLT={waitlistButtonLabelLT}
        waitlistSuccessLinkLT={waitlistSuccessLinkLT}
        noDatesAvailableLT={noDatesAvailableLT}
        showTimeSlots={showTimeSlots}
        navigation={navigation}
        shouldPersonalDataCollected={shouldPersonalDataCollected}
        slotsInfo={slots}
        loading={loading}
        filtersDatesProps={filtersDatesProps}
        useDiscountOnFlagship={useDiscountOnFlagship}
        discountFlagshipText={discountFlagshipText}
      />
    );

    return (
      <StyledLocationList
        className="location-list"
        ref={ref}
        $showDailyFilters={filtersDatesProps.showDailyFilters}
        $allItemsDisplayed={allItemsDisplayed}
      >
        {isFrance && impressParisClinic.length === 1 && (
          <Location
            key={impressParisClinic[0].id}
            ref={locationsRefs && locationsRefs[impressParisClinic[0].id]}
            location={impressParisClinic[0]}
            distancePlaceholder={distancePlaceholder}
            selectedLocationState={selectedLocationState}
            navigation={navigation}
            shouldPersonalDataCollected={shouldPersonalDataCollected}
            loading={loading}
            slotsInfo={slots}
            impressClinic={true}
            useDiscountOnFlagship={useDiscountOnFlagship}
            discountFlagshipText={discountFlagshipText}
          />
        )}
        {filteredLocations.map(renderLocation)}
        {!allItemsDisplayed && <LoaderSpinner color={corePalette.blue[500]} />}
      </StyledLocationList>
    );
  },
);

export default LocationsList;

LocationsList.propTypes = {
  locations: PropTypes.oneOfType([LocationType, PropTypes.arrayOf(LocationType)]),
  distancePlaceholder: PropTypes.string,
  bookingButtonLabel: PropTypes.string,
  selectedLocationState: PropTypes.array,
  locationsRefs: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.elementType })]),
};
